import { createUseQueryHook } from 'hooks/createUseQueryHook';

export const useAvailableCompanies = createUseQueryHook('available_companies', { staleTime: Infinity });
